import { render, staticRenderFns } from "./UM_userAgreement.vue?vue&type=template&id=214e44c0&"
import script from "./UM_userAgreement.vue?vue&type=script&lang=js&"
export * from "./UM_userAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports